<template>
  <div :class="styles">
    <div class="models-grid-template grid gap-4">
      <div
        class="w-full h-full p-4 rounded-xl bg-veturi-main text-veturi-white"
        v-for="cost of state.costs"
        :key="cost.id"
      >
        <form @submit.prevent="() => {}" class="grid grid-flow-row font-bold">
          <div class="grid grid-cols-2 gap-4 items-center justify-center">
            <button
              @click="() => removeMaterial(cost.id)"
              class="action-button bg-veturi-error"
            >
              <span class="font-bold mr-2">Excluir</span>
              <icon name="trash" />
            </button>
            <button
              @click="() => saveMaterial(cost)"
              class="action-button bg-veturi-dark"
            >
              <span class="font-bold mr-2">Salvar</span>
              <icon name="save" />
            </button>
          </div>
          <div class="form-group grid">
            <label :for="`material-name-${cost.id}`">
              Material
            </label>
            <input
              :id="`material-name-${cost.id}`"
              type="text"
              v-model="cost.name"
            />
          </div>
          <div class="form-group">
            <div class="grid grid-flow-col grid-cols-2 gap-4">
              <div class="grid">
                <label :for="`material-cost-${cost.id}`">
                  Custo por kg
                </label>
                <input
                  :id="`material-cost-${cost.id}`"
                  type="text"
                  v-model.number="cost.kg_cost"
                />
              </div>
              <div class="grid">
                <label :for="`material-yield-${cost.id}`">
                  Rendimento
                </label>
                <input
                  :id="`material-yield-${cost.id}`"
                  type="text"
                  v-model.number="cost.yield"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
      <div
        class="fixed bottom-4 right-4 bg-veturi-light text-veturi-white font-regular text-4xl h-12 w-12 flex items-center justify-center rounded-full cursor-pointer"
        @click="addMaterial"
      >+</div>
  </div>
</div>
</template>

<script>
import { computed, reactive } from 'vue'
import Icon from '../../components/Icon'
import { cost } from '../../services'

export default {
  props: {
    title: { type: String },
    name: { type: String },
    costs: { type: Array },
    class: { type: String }
  },

  components: { Icon },

  setup (props, { emit }) {
    const state = reactive({
      costs: []
    })

    state.costs = computed(() => {
      const temp = [...props.costs]
      // return temp.sort((a, b) => a.name > b.name ? 1 : -1)
      return temp
    })

    async function saveMaterial (costToSave) {
      await cost.updateCost(props.name, costToSave)
    }

    async function addMaterial () {
      const newCost = {
        name: 'Novo material',
        kg_cost: 0,
        yield: 0
      }
      await cost.createCost(props.name, newCost)
      emit('reload-costs')
    }

    async function removeMaterial (idToRemove) {
      await cost.deleteCost(props.name, idToRemove)
      emit('reload-costs')
    }

    return {
      styles: props.class,
      state,
      saveMaterial,
      addMaterial,
      removeMaterial
    }
  }
}
</script>

<style scoped>
.models-grid-template {
  grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));
  grid-template-rows: 1fr;
}

.action-button {
  @apply h-8 flex items-center justify-center rounded-full focus:outline-none;
}

input {
  @apply rounded-lg mt-1 w-full bg-veturi-white text-veturi-dark font-bold focus:border-veturi-accent border-veturi-white border-2;
}

.form-group {
  @apply mt-2;
}

fieldset {
  @apply form-group border-2 p-2 text-veturi-white border-veturi-white font-bold rounded-lg;
}
</style>
